// extracted by mini-css-extract-plugin
export default {"form_btn":"style_form_btn__Dw9My","green":"style_green__tVs9g","white":"style_white__sOT9S"};